import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#2D5016] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <img
              src="https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/f44ef6b76bca892c4b2b8ad1895f9c04.jpeg"
              alt="AGRO-INNOVAZIONI"
              className="h-10 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-white/70 text-sm mb-6">
              Qualità Biologica Certificata
            </p>
            <div className="flex items-center space-x-2">
              <input
                type="email"
                placeholder="La tua email"
                className="flex-1 px-4 py-2 bg-white/10 border border-white/30 rounded-lg text-sm text-white placeholder-white/50 focus:outline-none focus:border-white/50"
              />
              <button className="p-2 bg-white/20 hover:bg-white/30 rounded-lg transition-colors cursor-pointer">
                <i className="ri-notification-line text-white"></i>
              </button>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Esplora</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/prodotti" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Prodotti
                </Link>
              </li>
              <li>
                <Link to="/offerte" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Offerte
                </Link>
              </li>
              <li>
                <Link to="/azienda" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Chi Siamo
                </Link>
              </li>
              <li>
                <Link to="/media" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Media
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Categorie</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/prodotti" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Spezie Biologiche
                </Link>
              </li>
              <li>
                <Link to="/prodotti" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Biscotti da Tisana
                </Link>
              </li>
              <li>
                <Link to="/offerte" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Gift Box
                </Link>
              </li>
              <li>
                <Link to="/prodotti" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Novità
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Assistenza</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/contatti" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contatti" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Spedizioni
                </Link>
              </li>
              <li>
                <Link to="/contatti" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Resi
                </Link>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Termini e Condizioni
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/20">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-white/60 text-sm">
              © 2025 AGRO-INNOVAZIONI S.r.l - Tutti i diritti riservati
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-white"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-white"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-white"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-white"></i>
              </a>
            </div>
            <div className="flex items-center space-x-4">
              <a href="#" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <span className="text-white/40">|</span>
              <a href="#" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">
                Cookie Policy
              </a>
              <span className="text-white/40">|</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;